export const primary = "#ff8500";
export const aliceblue = "aliceblue";
